import React, { useEffect, useState } from 'react';
import { Typography, IconButton, TextField, Button, Box, Card, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { AutoAwesome, ChevronLeft, ChevronRight } from '@mui/icons-material';

const CardContentWithUtility = ({ initialContent, ...props }) => {
    // console.debug("genaiResponse : CardContentWithUtility : initialContent : ", initialContent);
    const [content, setContent] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState(content[0]);

    useEffect(function () {
        setContent(initialContent);
        props?.selectedPromptChangeHandler(initialContent[currentIndex])
    }, [initialContent]);
    const handleEdit = () => {
        console.debug("genAI : GenerativeAILayout : selectedPromptChangeHandler : edit : ", content);
        setIsEditing(true);
        setEditValue(content[currentIndex]);
    };
    
    const handleSave = () => {
        const updatedContent = [...content];
        updatedContent[currentIndex] = editValue;
        setContent(updatedContent);
        setIsEditing(false);
        props?.selectedPromptChangeHandler(updatedContent[currentIndex])
    };

    const handleDelete = () => {
        const updatedContent = content.filter((_, index) => index !== currentIndex);
        setContent(updatedContent);
        setCurrentIndex(0);
        setIsEditing(false);
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            if (isEditing) {
                setEditValue(content[currentIndex - 1]);
            }
            props?.selectedPromptChangeHandler(content[currentIndex - 1])
        }
    };

    const handleNext = () => {
        if (currentIndex < content.length - 1) {
            setCurrentIndex(currentIndex + 1);
            if (isEditing) {
                setEditValue(content[currentIndex + 1]);
            }
            props?.selectedPromptChangeHandler(content[currentIndex + 1])
        }
    };

    if (content.length == 0) {
        return "";
    } else {
        return (
            <Box
            //  sx={{ maxWidth: 345 }}
            >
                <Card sx={{ border: '0.5px solid #2563EB', p: '8px' }}>
                    <Box >
                        {isEditing ? (
                            <Box>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    value={editValue}
                                    multiline
                                    maxRows={3}
                                    onChange={(e) => setEditValue(e.target.value)}
                                />
                            </Box>
                        ) : (
                            <Box sx={{ height: '5.2rem', overflow: 'auto', padding: '0.2rem 0rem 0rem 0.5rem' }}>
                                <Typography variant="subtitle2" color="text.secondary">
                                    {content[currentIndex]}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <Divider sx={{ mt: 1 }} />
                    <Box display="flex" justifyContent="flex-end">
                        <Box sx={{ display: 'flex' }}>
                            <Box>
                                {isEditing ? (
                                    <IconButton onClick={handleSave} color="primary">
                                        <SaveIcon />
                                    </IconButton>
                                ) : (
                                    <IconButton onClick={handleEdit} color="primary">
                                        <EditIcon />
                                    </IconButton>
                                )}
                                <IconButton onClick={handleDelete} color="secondary">
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                            <Box sx={{ display: 'flex' }}>
                                <IconButton onClick={handlePrev} disabled={currentIndex === 0}>
                                    <ChevronLeft />
                                </IconButton>
                                <Typography sx={{ mt: 1 }}>
                                    {currentIndex + 1}/{content.length}
                                </Typography>
                                <IconButton onClick={handleNext} disabled={currentIndex === content.length - 1}>
                                    <ChevronRight />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>
                </Card>
                <Box mt='1.5rem'>
                    <Button name="generateContent" variant='outlined' startIcon={<AutoAwesome />}
                        disabled={props?.generatePromptLoading ? true : false}
                        onClick={props?.onGenerateContentWithAI}
                    >
                        {props?.generateButtonValue}

                    </Button>
                </Box>
            </Box>
        );
        // genratePromptButtonStatus
        // setGeneratePromptLoading
        // setGeneratePromptContentLoading
    }

};

export default CardContentWithUtility;
